<template>
  <div class="articleList" ref="container">
    <div class="slider-banner swiperNews" v-if="imgUrls.length > 0">
      <swiper class="swiper-wrapper" :options="swiperNew">
        <swiperSlide
          class="swiper-slide"
          v-for="(item, index) in imgUrls"
          :key="index"
        >
          <img :src="item.image_input[0]" class="slide-image" />
        </swiperSlide>
      </swiper>
      <div class="swiper-pagination"></div>
    </div>
    <Tabs
      @click="onClick"
      class="newsSwitch"
      line-height="0.04rem"
      line-width="0.24rem"
      color="#E68B26"
      v-model="active"
      animated
      title-inactive-color="#656574"
      title-active-color="#E68B26"
      nav-right="0.46rem"
      background="#F2F3F5"
      sticky
    >
      <Tab
        v-for="(item, index) in navLsit"
        :key="index"
        :title="item.title"
        title-inactive-color="#656574"
        title-active-color="#E68B26"
      >
        <div class="list" v-for="(item, index) in articleList" :key="index">
          <router-link
            :to="{ path: '/article_detail/' + item.id }"
            class="item acea-row row-between-wrapper"
            v-if="item.image_input.length > 0"
          >
            <div class="text acea-row row-column-between">
              <!-- v-if="item.is_top === 1" -->

              <div class="name line2">
                <img
                  v-if="item.is_top === 1"
                  class="show_top"
                  src="../../../assets/images/show_top.png"
                  alt=""
                />
                {{ item.title }}
              </div>
              <div>
                {{ item.add_date }}
                <span class="visit">
                  {{ item.visit }}<span class="read">阅读</span>
                </span>
              </div>
            </div>
            <div class="pictrue"><img :src="item.image_input[0]" /></div>
          </router-link>
        </div>
        <Loading
          :loaded="loadend"
          :loading="loading"
          v-if="index > 0 && articleList.length > 0"
        ></Loading>
        <!--暂无新闻-->
        <div class="noCommodity" v-if="articleList.length === 0 && page > 1">
          <div class="noPictrue">
            <img src="@assets/images/noNews.png" class="image" />
          </div>
        </div>
      </Tab>
    </Tabs>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import { Tab, Tabs } from "vant";
import { getArticleCategory, getArticleList } from "@api/public";
import Loading from "@components/Loading";

export default {
  name: "NewsList",
  components: {
    swiper,
    swiperSlide,
    Tab,
    Tabs,
    Loading
  },
  props: {},
  data: function() {
    return {
      page: 1,
      limit: 20,
      loadTitle: "",
      loading: false,
      loadend: false,
      imgUrls: [],
      navLsit: [],
      articleList: [],
      active: 0,
      cid: 0,
      swiperNew: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      }
    };
  },
  mounted: function() {
    this.articleCategory();
    this.getArticleLists();
    // this.articleHotList();
    // this.$scroll(this.$refs.container, () => {
    //   console.log(this.loading);
    //   !this.loading && this.getArticleLists();
    // });
  },
  methods: {
    articleCategory: function() {
      let that = this;
      getArticleCategory().then(res => {
        that.navLsit = res.data;
      });
    },
    getArticleLists: function() {
      let that = this;
      if (that.loading) return; //阻止下次请求（false可以进行请求）；
      if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
      that.loading = true;
      let q = {
        page: that.page,
        limit: that.limit
      };
      getArticleList(q, that.cid).then(res => {
        that.loading = false;
        res.data = res.data.map(item => {
          item.add_date = item.add_time ? item.add_time.split(" ")[0] : `''`;
          return item;
        });
        //apply();js将一个数组插入另一个数组;
        that.articleList.push.apply(that.articleList, res.data);
        that.loadend = res.data.length < that.limit; //判断所有数据是否加载完成；
        that.page = that.page + 1;
      });
    },
    onClick: function(name) {
      // if (name === 0) this.articleHotList();
      // else {
      //   this.cid = this.navLsit[name].id;
      //   this.articleList = [];
      //   this.page = 1;
      //   this.loadend = false;
      //   this.loading = false;
      //   this.getArticleLists(name);
      // }
      this.cid = this.navLsit[name].id;
      this.articleList = [];
      this.page = 1;
      this.loadend = false;
      this.loading = false;
      this.getArticleLists(name);
    }
  }
};
</script>
<style scoped>
.articleList {
  background: #f2f3f5;
  padding-bottom: 0.2rem;
  min-height: 100vh;
}
.list {
  margin-top: 0.3rem;
}
.item {
  background: #FFFFFF;
  box-shadow: 0px 13px 50px 0px rgba(55, 154, 243, 0.08) !important;
  border-radius: 0.2rem !important;
  padding: 0.26rem 0.24rem 0.38rem 0.26rem !important;
}
.visit {
  margin-left: 0.28rem;
}
.read {
  margin-left: 0.04rem;
}
.show_top {
  width: 0.6rem;
  height: 0.34rem;
  vertical-align: sub;
}
</style>
